var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWinter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1187.5 1091.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-4,.cls-42,.cls-43,.cls-45,.cls-47,.cls-49,.cls-5,.cls-51,.cls-53,.cls-56,.cls-59,.cls-6,.cls-61,.cls-63,.cls-7,.cls-8,.cls-9{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-1,.cls-3,.cls-4{clip-rule:evenodd;}.cls-10,.cls-2,.cls-31,.cls-32,.cls-34,.cls-35,.cls-36,.cls-37,.cls-43,.cls-45,.cls-49,.cls-5,.cls-51,.cls-53,.cls-59,.cls-6,.cls-61,.cls-63,.cls-7,.cls-8,.cls-9{fill-rule:evenodd;}.cls-3,.cls-42,.cls-7{stroke-dasharray:20 10 33.14 0.11;}.cls-4,.cls-45,.cls-47{stroke-dasharray:100 10 30 5;}.cls-27,.cls-5{stroke-dasharray:3.28 2.76 33.14 0.11;}.cls-6{stroke-dasharray:16 10 33.14 0.11;}.cls-8{stroke-dasharray:6.57 3.94 33.14 0.11;}.cls-9{stroke-dasharray:2 6 33.14 0.11;}.cls-10{stroke-dasharray:6.57 3.28 393.98 1.31;}.cls-12{stroke-dasharray:34.14 2.63 0 0;}.cls-13{stroke-dasharray:9 5 0 0;}.cls-14{stroke-dasharray:40.85 3.14 0 0;}.cls-15{stroke-dasharray:10.77 5.98 0 0;}.cls-16{stroke-dasharray:54.9 4.22 0 0;}.cls-17{stroke-dasharray:14.47 8.04 0 0;}.cls-18{stroke-dasharray:34 4 0 0;}.cls-19{stroke-dasharray:16 5 0 0;}.cls-20{stroke-dasharray:12 6 0 0;}.cls-21{stroke-dasharray:18 6 0 0;}.cls-22{stroke-dasharray:96 13 0 0;}.cls-23{stroke-dasharray:20 8 0 0;}.cls-24,.cls-36{stroke-dasharray:84 8 0 0;}.cls-25{stroke-dasharray:12 5 0 0;}.cls-26{stroke-dasharray:12 6;}.cls-28{stroke-dasharray:20 4 0 0;}.cls-29{stroke-dasharray:73 11 0 0;}.cls-30{stroke-dasharray:7 6 33.14 0.11;}.cls-31{stroke-dasharray:69 11 0 0;}.cls-32{stroke-dasharray:80 10 0 0;}.cls-33,.cls-34{stroke-dasharray:76 10 33.14 0.11;}.cls-35{stroke-dasharray:56.47 6.57 0 0;}.cls-37{stroke-dasharray:10 10 33.14 0.11;}.cls-38{clip-path:url(#clip-path);}.cls-39{clip-path:url(#clip-path-3);}.cls-40{clip-path:url(#clip-path-4);}.cls-41{clip-path:url(#clip-path-5);}.cls-43{stroke-dasharray:23 10 33.14 0.11;}.cls-44{clip-path:url(#clip-path-6);}.cls-46{clip-path:url(#clip-path-7);}.cls-48{clip-path:url(#clip-path-8);}.cls-49{stroke-dasharray:58 11 0 0;}.cls-50{clip-path:url(#clip-path-9);}.cls-51{stroke-dasharray:76 10 30 7;}.cls-52{clip-path:url(#clip-path-11);}.cls-53{stroke-dasharray:57 6 0 0;}.cls-54{clip-path:url(#clip-path-13);}.cls-55{clip-path:url(#clip-path-14);}.cls-56{stroke-dasharray:13.79 3.28 393.98 1.31;}.cls-57{clip-path:url(#clip-path-16);}.cls-58{clip-path:url(#clip-path-17);}.cls-59{stroke-dasharray:46 8 0 0;}.cls-60{clip-path:url(#clip-path-18);}.cls-61{stroke-dasharray:28.27 2.17 0 0;}.cls-62{clip-path:url(#clip-path-20);}.cls-63{stroke-dasharray:100 10 30 9;}.cls-64{clip-path:url(#clip-path-22);}.cls-65{clip-path:url(#clip-path-24);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M473.09,360.17a15.9,15.9,0,1,0,11.24-4.65v-6.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.12,61.27a15.9,15.9,0,1,0,11.24-4.65V50Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.83,135.85A21.5,21.5,0,1,0,34,129.56v-8.91Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.49,613.52a16.59,16.59,0,1,0,11.73-4.86v-6.87Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.49,613.52a16.59,16.59,0,1,0,11.73-4.86v-6.87Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M480,840a25.65,25.65,0,1,0,18.15-7.52V821.83Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M480,840a25.65,25.65,0,1,0,18.15-7.52V821.83Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.48,873.08a17.52,17.52,0,1,0,12.4-5.14v-7.26Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M651.26,946.4a15.87,15.87,0,1,0,11.24-4.66v-6.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.15,1061.71a10.33,10.33,0,1,0,7.31-3v-4.28Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.93,450.78a15.23,15.23,0,1,0,10.76-4.45V440Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M775.13,135.85a21.5,21.5,0,1,0,15.19-6.29v-8.91Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M851.77,873.08a17.52,17.52,0,1,0,12.4-5.14v-7.26Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M967.39,1056.78a10.33,10.33,0,1,0,7.31-3v-4.28Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1017.37,349.62a13.17,13.17,0,1,0,9.3-3.85v-5.45Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M877.78,469.15a22.34,22.34,0,1,0,15.79-6.54v-9.25Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M650.38,535.58a10.33,10.33,0,1,0,7.31-3v-4.28Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.91,307.28a32.22,32.22,0,0,0,5.24,29.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M702.78,483.21c-.3,1,2.91,16.69,15.63,26.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M800.75,346.52c.09,1.7-10.43,24.72-33.4,34.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M954.5,276.46c-1.6.58-26.68-2.88-42.88-22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M628.75,693.36s-.11-17,21.85-32.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M38.85,988.25s12.18-2.47,25.73,7.31,16.68,18.13,16.68,18.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M406.7,670.82a42.19,42.19,0,0,0,10.47,16.83c16,15.14,31.17,14.5,31.17,14.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M339.77,805s-7.07,19.31-20,29-25.1,9.43-25.1,9.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1031.06,86.48s-2.51,26.35,24.56,43.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1171.38,1036.18c1.42-2,2.94-4.4,4.54-7.08,9.7-16.25,8-31,8-31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1066.09,696.41a42.25,42.25,0,0,0,15.36,12.51c20,9.14,34.2,3.59,34.2,3.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1081.27,861.16s-1.32,13.2-7.83,21.33-14.17,9.92-14.17,9.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "732.86 472.81 740.65 467.11 739.6 476.7 748.43 480.59 739.6 484.49 740.65 494.08 732.86 488.38 725.07 494.08 726.11 484.49 717.28 480.59 726.11 476.7 725.07 467.11 732.86 472.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M728.25,464.69l4.61,3.37,4.59-3.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M717,476.48l5.22-2.3-.61-5.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M721.64,492.1l.61-5.67-5.21-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M737.46,495.92l-4.6-3.37-4.59,3.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M748.68,484.13l-5.22,2.3.62,5.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M744.08,468.51l-.62,5.67,5.21,2.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 732.86,
    y1: 461.84,
    x2: 732.86,
    y2: 499.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 716.72,
    y1: 471.02,
    x2: 749.2,
    y2: 489.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 716.51,
    y1: 489.74,
    x2: 749,
    y2: 470.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "422.59 1052.04 431.91 1045.22 430.66 1056.7 441.23 1061.36 430.66 1066.01 431.91 1077.49 422.59 1070.67 413.27 1077.49 414.52 1066.01 403.96 1061.36 414.52 1056.7 413.27 1045.22 422.59 1052.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M417.08,1042.33l5.51,4,5.5-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M403.66,1056.44l6.25-2.76-.74-6.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M409.17,1075.12l.74-6.79-6.24-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M428.1,1079.69l-5.51-4-5.49,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M441.53,1065.58l-6.25,2.75.74,6.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M436,1046.9l-.74,6.78,6.23,2.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 422.59,
    y1: 1038.92,
    x2: 422.59,
    y2: 1083.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 403.28,
    y1: 1049.9,
    x2: 442.15,
    y2: 1072.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 403.04,
    y1: 1072.3,
    x2: 441.9,
    y2: 1049.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1035.96 844.78 1048.48 835.62 1046.81 851.04 1061.01 857.3 1046.81 863.57 1048.48 878.99 1035.96 869.83 1023.44 878.99 1025.12 863.57 1010.92 857.3 1025.12 851.04 1023.44 835.62 1035.96 844.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1028.56,831.73l7.4,5.42,7.39-5.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1010.52,850.7l8.39-3.71-1-9.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1017.92,875.8l1-9.12-8.37-3.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1043.37,882l-7.41-5.42-7.38,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1061.41,863l-8.4,3.7,1,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1054,837.88l-1,9.11,8.38,3.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 1035.96,
    y1: 827.15,
    x2: 1035.96,
    y2: 887.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 1010.01,
    y1: 841.91,
    x2: 1062.24,
    y2: 872.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 1009.68,
    y1: 872.01,
    x2: 1061.92,
    y2: 841.85
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "949.52 216.67 961.6 207.82 959.98 222.71 973.68 228.75 959.98 234.79 961.6 249.68 949.52 240.83 937.43 249.68 939.05 234.79 925.35 228.75 939.05 222.71 937.43 207.82 949.52 216.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M942.37,204.07l7.15,5.23,7.12-5.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M925,222.37l8.1-3.57-.95-8.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M932.1,246.6l1-8.8L925,234.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M956.66,252.53l-7.14-5.23-7.13,5.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M974.07,234.23,966,237.8l1,8.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M966.93,210l-1,8.8,8.08,3.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 949.52,
    y1: 199.65,
    x2: 949.52,
    y2: 257.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 924.47,
    y1: 213.9,
    x2: 974.88,
    y2: 243
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 924.15,
    y1: 242.94,
    x2: 974.56,
    y2: 213.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "673.58 689.86 685.88 680.85 684.23 696 698.17 702.15 684.23 708.3 685.88 723.45 673.58 714.45 661.28 723.45 662.93 708.3 648.99 702.15 662.93 696 661.28 680.85 673.58 689.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M666.31,677l7.27,5.32,7.25-5.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M648.59,695.66l8.24-3.63-1-8.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M655.86,720.32l1-9-8.22-3.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M680.85,726.35,673.58,721l-7.25,5.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M698.56,707.73l-8.24,3.63,1,8.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M691.3,683.07l-1,9,8.23,3.62"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 673.58,
    y1: 672.54,
    x2: 673.58,
    y2: 731.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 648.09,
    y1: 687.04,
    x2: 699.39,
    y2: 716.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 647.77,
    y1: 716.59,
    x2: 699.06,
    y2: 686.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1096.45 642.41 1111.89 631.11 1109.82 650.13 1127.33 657.85 1109.82 665.57 1111.89 684.58 1096.45 673.28 1081.02 684.58 1083.09 665.57 1065.58 657.85 1083.09 650.13 1081.02 631.11 1096.45 642.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1087.33,626.32l9.12,6.68,9.11-6.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1065.09,649.7l10.35-4.56-1.22-11.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1074.21,680.65l1.23-11.24-10.33-4.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1105.58,688.22l-9.13-6.68-9.1,6.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1127.82,664.85l-10.35,4.56,1.22,11.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1118.69,633.9l-1.22,11.24,10.33,4.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1096.45,
    y1: 620.67,
    x2: 1096.45,
    y2: 695.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1064.46,
    y1: 638.88,
    x2: 1128.85,
    y2: 676.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1064.06,
    y1: 675.98,
    x2: 1128.45,
    y2: 638.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "44.81 1018.46 54.91 1011.07 53.56 1023.52 65.01 1028.57 53.56 1033.62 54.91 1046.07 44.81 1038.67 34.7 1046.07 36.06 1033.62 24.6 1028.57 36.06 1023.52 34.7 1011.07 44.81 1018.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M38.83,1007.93l6,4.38,6-4.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M24.28,1023.24l6.77-3-.8-7.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M30.25,1043.49l.8-7.35-6.76-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M50.78,1048.45l-6-4.37-6,4.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M65.34,1033.15l-6.78,3,.8,7.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M59.36,1012.89l-.8,7.36,6.76,3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 44.81,
    y1: 1004.24,
    x2: 44.81,
    y2: 1052.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 23.87,
    y1: 1016.15,
    x2: 66.01,
    y2: 1040.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 23.6,
    y1: 1040.43,
    x2: 65.75,
    y2: 1016.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "112.5 300.65 126.55 290.36 124.67 307.67 140.6 314.7 124.67 321.72 126.55 339.03 112.5 328.75 98.45 339.03 100.33 321.72 84.4 314.7 100.33 307.67 98.45 290.36 112.5 300.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M104.2,286l8.3,6.08,8.29-6.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M84,307.28l9.42-4.15-1.11-10.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M92.26,335.46l1.11-10.24L84,321.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M120.81,342.35l-8.31-6.08-8.29,6.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M141.06,321.07l-9.42,4.15,1.11,10.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M132.75,292.89l-1.11,10.24,9.39,4.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 112.5,
    y1: 280.86,
    x2: 112.5,
    y2: 348.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 83.38,
    y1: 297.43,
    x2: 141.99,
    y2: 331.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 83.01,
    y1: 331.2,
    x2: 141.63,
    y2: 297.36
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "294.04 775.64 308.09 765.36 306.21 782.67 322.14 789.69 306.21 796.72 308.09 814.03 294.04 803.75 279.99 814.03 281.87 796.72 265.94 789.69 281.87 782.67 279.99 765.36 294.04 775.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M285.74,761l8.3,6.08,8.29-6.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M265.49,782.28l9.42-4.16-1.11-10.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M273.8,810.45l1.11-10.23-9.4-4.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M302.35,817.35,294,811.26l-8.29,6.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M322.59,796.06l-9.42,4.16,1.12,10.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M314.29,767.89l-1.12,10.23,9.4,4.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 294.04,
    y1: 755.85,
    x2: 294.04,
    y2: 823.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 264.92,
    y1: 772.42,
    x2: 323.53,
    y2: 806.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 264.55,
    y1: 806.2,
    x2: 323.16,
    y2: 772.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M422.95,617.74h72.83a0,0,0,0,1,0,0v25a36.36,36.36,0,0,1-36.36,36.36h-.1a36.36,36.36,0,0,1-36.36-36.36v-25A0,0,0,0,1,422.95,617.74Z",
    transform: "translate(-235.49 262.87) rotate(-25.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M412.66,593.11a8.3,8.3,0,0,0,6.83,13.19h0a8.31,8.31,0,0,1,6.83,13.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M429,585.28a8.31,8.31,0,0,0,6.83,13.19h0a8.3,8.3,0,0,1,6.83,13.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M445.25,577.45a8.3,8.3,0,0,0,6.83,13.19h0a8.3,8.3,0,0,1,6.83,13.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M490.27,604.29l-9.51,4.57L484,615.7l8-3.84a11,11,0,0,1,9.54,19.87l-9,4.32a36.19,36.19,0,0,1,.7,8.08l13.09-6.29a16.93,16.93,0,0,0,7.93-22.59l-1.46-3A16.91,16.91,0,0,0,490.27,604.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1118.27,962.46h51.11a0,0,0,0,1,0,0V980a25.52,25.52,0,0,1-25.52,25.52h-.07A25.52,25.52,0,0,1,1118.27,980V962.46a0,0,0,0,1,0,0Z",
    transform: "translate(-313.29 592.37) rotate(-25.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1111,945.17a5.83,5.83,0,0,0,4.8,9.26h0a5.82,5.82,0,0,1,4.79,9.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1122.48,939.68a5.82,5.82,0,0,0,4.79,9.25h0a5.83,5.83,0,0,1,4.8,9.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1133.92,934.19a5.82,5.82,0,0,0,4.79,9.25h0a5.82,5.82,0,0,1,4.79,9.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1165.51,953l-6.68,3.21,2.31,4.79,5.61-2.69a7.73,7.73,0,1,1,6.7,13.94l-6.31,3a25.33,25.33,0,0,1,.49,5.67l9.19-4.41a11.88,11.88,0,0,0,5.56-15.85l-1-2.13A11.88,11.88,0,0,0,1165.51,953Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M281,371.49H281a24.15,24.15,0,0,1,24.15,24.15v16.6a0,0,0,0,1,0,0H256.83a0,0,0,0,1,0,0v-16.6A24.15,24.15,0,0,1,281,371.49Z",
    transform: "translate(364.62 866.78) rotate(-154.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M312,355.13a5.51,5.51,0,0,1-4.54,8.76h0a5.51,5.51,0,0,0-4.53,8.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M301.21,349.93a5.51,5.51,0,0,1-4.53,8.76h0a5.52,5.52,0,0,0-4.54,8.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M290.39,344.73a5.52,5.52,0,0,1-4.54,8.76h0a5.52,5.52,0,0,0-4.54,8.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M260.48,362.56l6.32,3-2.18,4.55-5.31-2.56a7.32,7.32,0,0,0-6.34,13.2l6,2.87a24.43,24.43,0,0,0-.47,5.37l-8.69-4.18a11.24,11.24,0,0,1-5.27-15l1-2A11.24,11.24,0,0,1,260.48,362.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M758.1,300.89h.08a29.42,29.42,0,0,1,29.42,29.42v20.21a0,0,0,0,1,0,0H728.68a0,0,0,0,1,0,0V330.31A29.42,29.42,0,0,1,758.1,300.89Z",
    transform: "translate(1300.47 947.6) rotate(-154.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M795.93,281a6.72,6.72,0,0,1-5.52,10.67h0a6.72,6.72,0,0,0-5.53,10.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M782.75,274.63a6.72,6.72,0,0,1-5.53,10.67h0A6.72,6.72,0,0,0,771.7,296"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M769.56,268.3A6.72,6.72,0,0,1,764,279h0a6.72,6.72,0,0,0-5.53,10.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M733.14,290l7.69,3.7-2.65,5.53-6.47-3.11A8.92,8.92,0,0,0,724,312.21l7.28,3.49a29.57,29.57,0,0,0-.57,6.54l-10.59-5.09a13.68,13.68,0,0,1-6.41-18.27l1.18-2.46A13.7,13.7,0,0,1,733.14,290Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1046.46,78.39h43.63a0,0,0,0,1,0,0v15a21.78,21.78,0,0,1-21.78,21.78h-.06a21.78,21.78,0,0,1-21.78-21.78v-15A0,0,0,0,1,1046.46,78.39Z",
    transform: "translate(63.46 472.15) rotate(-25.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1040.3,63.63a5,5,0,0,0,4.09,7.9h0a5,5,0,0,1,4.09,7.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1050.06,58.94a5,5,0,0,0,4.09,7.9h0a5,5,0,0,1,4.09,7.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1059.82,54.25a5,5,0,0,0,4.09,7.9h0a5,5,0,0,1,4.09,7.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1086.79,70.33l-5.7,2.74,2,4.09,4.79-2.3a6.61,6.61,0,0,1,5.72,11.91l-5.39,2.58a21.46,21.46,0,0,1,.42,4.84l7.85-3.76a10.14,10.14,0,0,0,4.74-13.53l-.87-1.82A10.13,10.13,0,0,0,1086.79,70.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M501.59,387.9a24.4,24.4,0,1,0-17.26,7.16v10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M417.63,89a24.43,24.43,0,1,0-17.27,7.15v10.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M148.32,20s-7.31.88-13,11.42c-6.41,11.79-18.56,12.6-21.24,3.86a16.86,16.86,0,0,1-.59-3.78s-10.64-3.39-6.61-12.42S124,8.8,134.46,12,148.32,20,148.32,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M102.17,43.15c.4-.2,10.42-17.3,31.06-22.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M115.92,28.08a11.91,11.91,0,0,1,.45-4.65,10,10,0,0,1,3.16-4.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M123.16,25.29a11.68,11.68,0,0,1,5.71,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M297.11,494.82s7.31-.88,13-11.42c6.41-11.8,18.55-12.61,21.23-3.86a16.41,16.41,0,0,1,.6,3.77s10.63,3.4,6.61,12.43-17.15,10.32-27.62,7.13S297.11,494.82,297.11,494.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M343.26,471.71c-.4.2-10.42,17.3-31.06,22.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M329.51,486.78a12.06,12.06,0,0,1-.46,4.65,9.93,9.93,0,0,1-3.16,4.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M322.26,489.57a11.76,11.76,0,0,1-5.7-3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1.93,397.81s7.31-.89,13-11.42c6.41-11.8,18.55-12.61,21.23-3.87a16.23,16.23,0,0,1,.59,3.78s10.64,3.4,6.62,12.43-17.15,10.32-27.62,7.13S1.93,397.81,1.93,397.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M48.09,374.69c-.41.21-10.43,17.3-31.06,22.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M34.33,389.76a12,12,0,0,1-.45,4.66A10,10,0,0,1,30.72,399"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M27.09,392.55a11.63,11.63,0,0,1-5.7-3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M79.09,732.63s7.31-.89,13-11.42c6.41-11.8,18.55-12.61,21.24-3.87a16.86,16.86,0,0,1,.59,3.78s10.64,3.4,6.61,12.43S103.42,743.87,93,740.68,79.09,732.63,79.09,732.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M125.24,709.51c-.4.21-10.42,17.3-31.06,22.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M111.49,724.58a12,12,0,0,1-.45,4.66,10,10,0,0,1-3.16,4.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M104.25,727.37a11.71,11.71,0,0,1-5.71-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M529.07,146.58a43,43,0,0,1,12.72-7.2c5.85-2,13.59-3.28,21.11-.06,15,6.44,9.8,15.29,6.27,18.15l-3.53,2.87s2.82,9.86-4.95,12-16.58-3.08-19.77-14.74-13.14-10-13.14-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M543.81,148.4a38.71,38.71,0,0,1,15.1,5.1c6.94,4.35,14.45,16.94,14.45,16.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M562.74,156.6a10.9,10.9,0,0,0-10.57,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M555.27,151.56s-1.74-3.09-1-5.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1142.21,300.44a43,43,0,0,1,12.72-7.2c5.85-2,13.59-3.28,21.11-.06,15,6.44,9.8,15.29,6.27,18.15l-3.53,2.87s2.82,9.86-5,12-16.58-3.08-19.77-14.74-13.14-10-13.14-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1157,302.26a38.78,38.78,0,0,1,15.11,5.1c6.93,4.35,14.44,16.94,14.44,16.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1175.88,310.46a10.9,10.9,0,0,0-10.57,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1168.42,305.42s-1.75-3.09-1-5.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M306.43,210.31s2.64-13.2,13.76-17.86,14.66-4,14.66-4-3.83,3.73-10,13.66S306.43,210.31,306.43,210.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M554.79,265.14s13.2,2.64,17.86,13.76,4,14.66,4,14.66-3.74-3.83-13.66-10S554.79,265.14,554.79,265.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M592.94,289s8.11-9.66,17.32-7.66,11.09,4.41,11.09,4.41-4.21,1.09-12.9,6.15S592.94,289,592.94,289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.77,636.21s-10.55,8.37-22,4.74-13.79-6.4-13.79-6.4,5.34-.38,16.44-4S80.77,636.21,80.77,636.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.74,649.92s2.12,12.43-5.35,18.16-10.54,5.62-10.54,5.62,1.89-3.92,3.65-13.82S52.74,649.92,52.74,649.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.85,237.06s5.1-9.08-.69-16.87c-4.13-5.55-13.46-6.45-13.46-6.45s2.7,6.44,4.62,12.16C292.59,232.67,299.85,237.06,299.85,237.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M576.92,1066s-1.85,13.34-12.67,18.66-14.4,4.88-14.4,4.88,3.6-4,9.14-14.23S576.92,1066,576.92,1066Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M581.9,1038.92s-4.56,9.37,1.69,16.8c4.46,5.3,13.82,5.64,13.82,5.64s-3.08-6.27-5.34-11.87C589.4,1042.87,581.9,1038.92,581.9,1038.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M360.89,496s16.15-12.32,11.54-36.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M105.94,1s-25.1,8.41-29.5,40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M130.45,759.43s21.15-12.32,22.89-38.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M587.63,158.49c1.64.42,20.37,17.45,22.93,42.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M696.18,26.33c1.69-.15,25,9.73,35.66,32.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1113.4,288.79c.71-1.54,20.9-16.82,45.87-14.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M395.37,1038.92c-1.42,2-2.93,4.4-4.54,7.08-9.69,16.24-8,31-8,31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M303.51,913.48s-2.05,20.46-12.13,33.06-22,15.38-22,15.38"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 466.89,
    y: 348.94,
    width: 34.88,
    height: 39.91
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M473.09,360.17a15.9,15.9,0,1,0,11.24-4.65v-6.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 466.89,
    y: 348.94,
    width: 34.88,
    height: 39.91
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M473.09,360.17a15.9,15.9,0,1,0,11.24-4.65v-6.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 382.92,
    y: 50.04,
    width: 34.88,
    height: 39.91
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M389.12,61.27a15.9,15.9,0,1,0,11.24-4.65V50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M57.38,173.35A33,33,0,1,0,34,183v13.69Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 10.44,
    y: 120.65,
    width: 47.17,
    height: 53.98
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.83,135.85A21.5,21.5,0,1,0,34,129.56v-8.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M233.25,642.48a25.49,25.49,0,1,0-18,7.47v10.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 197.01,
    y: 601.79,
    width: 36.42,
    height: 41.67
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M203.49,613.52a16.59,16.59,0,1,0,11.73-4.86v-6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M233.25,642.48a25.49,25.49,0,1,0-18,7.47v10.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 197.01,
    y: 601.79,
    width: 36.42,
    height: 41.67
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.49,613.52a16.59,16.59,0,1,0,11.73-4.86v-6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M526,884.75a39.45,39.45,0,1,0-27.89,11.55v16.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 469.97,
    y: 821.83,
    width: 56.33,
    height: 64.45
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M480,840a25.65,25.65,0,1,0,18.15-7.52V821.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M526,884.75a39.45,39.45,0,1,0-27.89,11.55v16.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 469.97,
    y: 821.83,
    width: 56.33,
    height: 64.45
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M480,840a25.65,25.65,0,1,0,18.15-7.52V821.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M126.93,903.67a26.94,26.94,0,1,0-19.05,7.89v11.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 88.64,
    y: 860.68,
    width: 38.48,
    height: 44.03
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.48,873.08a17.52,17.52,0,1,0,12.4-5.14v-7.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 88.64,
    y: 860.68,
    width: 38.48,
    height: 44.03
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.48,873.08a17.52,17.52,0,1,0,12.4-5.14v-7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M679.77,974.13a24.43,24.43,0,1,0-17.27,7.15V991.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 645.06,
    y: 935.16,
    width: 34.88,
    height: 39.91
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M651.26,946.4a15.87,15.87,0,1,0,11.24-4.66v-6.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 645.06,
    y: 935.16,
    width: 34.88,
    height: 39.91
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M651.26,946.4a15.87,15.87,0,1,0,11.24-4.66v-6.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M301.69,1079.75a15.9,15.9,0,1,0-11.23,4.65V1091Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 279.11,
    y: 1054.4,
    width: 22.69,
    height: 25.97
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.15,1061.71a10.33,10.33,0,1,0,7.31-3v-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M123.22,477.33a23.37,23.37,0,1,0-16.53,6.85v9.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 89.99,
    y: 440.03,
    width: 33.39,
    height: 38.21
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.93,450.78a15.23,15.23,0,1,0,10.76-4.45V440Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 89.99,
    y: 440.03,
    width: 33.39,
    height: 38.21
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.93,450.78a15.23,15.23,0,1,0,10.76-4.45V440Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1053.4,494.82s7.31-.88,13-11.42c6.41-11.8,18.55-12.61,21.23-3.86a16.41,16.41,0,0,1,.6,3.77s10.63,3.4,6.61,12.43-17.15,10.32-27.62,7.13S1053.4,494.82,1053.4,494.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1099.55,471.71c-.4.2-10.42,17.3-31.06,22.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1085.8,486.78a12.16,12.16,0,0,1-.45,4.65,10,10,0,0,1-3.17,4.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1078.56,489.57a11.77,11.77,0,0,1-5.71-3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M835.38,732.63s7.31-.89,13-11.42c6.41-11.8,18.55-12.61,21.23-3.87a16.86,16.86,0,0,1,.59,3.78s10.64,3.4,6.62,12.43-17.15,10.32-27.62,7.13S835.38,732.63,835.38,732.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M881.53,709.51c-.4.21-10.42,17.3-31,22.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M867.78,724.58a12,12,0,0,1-.45,4.66,10,10,0,0,1-3.16,4.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M860.54,727.37a11.71,11.71,0,0,1-5.71-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M813.4,1010.29s-7.31.88-13,11.42c-6.41,11.79-18.55,12.6-21.23,3.86a16.86,16.86,0,0,1-.59-3.78s-10.64-3.39-6.62-12.42,17.15-10.32,27.62-7.14S813.4,1010.29,813.4,1010.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M767.24,1033.4c.41-.2,10.43-17.3,31.06-22.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M781,1018.33a11.91,11.91,0,0,1,.45-4.65,10,10,0,0,1,3.16-4.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M788.24,1015.54a11.63,11.63,0,0,1,5.7,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1071.07,237s2.64-13.2,13.76-17.86,14.66-4,14.66-4-3.83,3.74-10,13.66S1071.07,237,1071.07,237Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M832,634.77s-10.55,8.37-22.05,4.75-13.78-6.41-13.78-6.41,5.33-.37,16.43-4S832,634.77,832,634.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M789.11,648.48s2.12,12.44-5.36,18.17-10.53,5.61-10.53,5.61,1.89-3.92,3.64-13.82S789.11,648.48,789.11,648.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1021,745.86s.77-13.44,11.14-19.6,13.95-6,13.95-6-3.27,4.23-8,14.92S1021,745.86,1021,745.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1039.32,704.77s-10.69-6.7-10-16.09,2.83-11.59,2.83-11.59,1.66,4,7.88,11.91S1039.32,704.77,1039.32,704.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1064.49,263.71s5.1-9.09-.7-16.88c-4.13-5.55-13.46-6.45-13.46-6.45s2.71,6.44,4.63,12.16C1057.23,259.31,1064.49,263.71,1064.49,263.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1117.18,496s16.15-12.32,11.54-36.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M878.27,431.37s-26.17,3.93-36,34.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M886.74,759.43s21.15-12.32,22.89-38.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M794.47,988s12.18-2.46,25.73,7.31,16.67,18.13,16.67,18.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M813.68,173.35A33,33,0,1,0,790.32,183v13.69Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 766.73,
    y: 120.65,
    width: 47.17,
    height: 53.98
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M775.13,135.85a21.5,21.5,0,1,0,15.19-6.29v-8.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M883.22,903.67a26.94,26.94,0,1,0-19.05,7.89v11.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 844.93,
    y: 860.68,
    width: 38.48,
    height: 44.03
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M851.77,873.08a17.52,17.52,0,1,0,12.4-5.14v-7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M883.22,903.67a26.94,26.94,0,1,0-19.05,7.89v11.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M985.93,1074.82a15.9,15.9,0,1,0-11.23,4.65v6.59Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 963.35,
    y: 1049.47,
    width: 22.69,
    height: 25.97
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M967.39,1056.78a10.33,10.33,0,1,0,7.31-3v-4.28Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 963.35,
    y: 1049.47,
    width: 22.69,
    height: 25.97
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M967.39,1056.78a10.33,10.33,0,1,0,7.31-3v-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1041,372.58a20.22,20.22,0,1,0-14.3,5.92v8.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1012.23,
    y: 340.32,
    width: 28.88,
    height: 33.04
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1017.37,349.62a13.17,13.17,0,1,0,9.3-3.85v-5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1041,372.58a20.22,20.22,0,1,0-14.3,5.92v8.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1012.23,
    y: 340.32,
    width: 28.88,
    height: 33.04
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1017.37,349.62a13.17,13.17,0,1,0,9.3-3.85v-5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M917.85,508.13a34.34,34.34,0,1,0-24.28,10V532.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 869.06,
    y: 453.36,
    width: 49.03,
    height: 56.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M877.78,469.15a22.34,22.34,0,1,0,15.79-6.54v-9.25Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 869.06,
    y: 453.36,
    width: 49.03,
    height: 56.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M877.78,469.15a22.34,22.34,0,1,0,15.79-6.54v-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M905.85,20.31s-7.31.89-13,11.42c-6.41,11.8-18.55,12.61-21.23,3.87a16.86,16.86,0,0,1-.59-3.78s-10.64-3.4-6.62-12.43S881.52,9.07,892,12.26,905.85,20.31,905.85,20.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M859.7,43.43c.4-.21,10.42-17.3,31-22.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M873.45,28.36a12,12,0,0,1,.45-4.66,10,10,0,0,1,3.16-4.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M880.69,25.57A11.68,11.68,0,0,1,886.4,29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M863.47,1.28s-25.1,8.41-29.5,40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M480.76,535.54s7.17-11.39,19.23-11.77,15.13,1.47,15.13,1.47-4.91,2.12-14.19,9.2S480.76,535.54,480.76,535.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M516.64,508.42s-6.12-11-1-18.92,8.08-8.78,8.08-8.78-.49,4.32,1.13,14.24S516.64,508.42,516.64,508.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M668.92,553.62a15.87,15.87,0,1,0-11.23,4.66v6.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 646.34,
    y: 528.27,
    width: 22.69,
    height: 25.97
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M650.38,535.58a10.33,10.33,0,1,0,7.31-3v-4.28Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 646.34,
    y: 528.27,
    width: 22.69,
    height: 25.97
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M650.38,535.58a10.33,10.33,0,1,0,7.31-3v-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M254.38,220.79c-1.21-1.2-8.86-25.33,1.45-48.17"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinter);
export default __webpack_public_path__ + "static/media/winter.45af79f8d57c3ccff9ab7a7690e4b4c2.svg";
export { ForwardRef as ReactComponent };